import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function useTripleWhalePageView() {
  const location = useLocation();
  const attemptsRef = useRef(0);

  useEffect(() => {
    attemptsRef.current = 0;

    function firePageView() {
      if (typeof (window as any).TriplePixel === "function") {
        (window as any).TriplePixel("PageView");
      } else if (attemptsRef.current < 5) {
        attemptsRef.current += 1;
        setTimeout(firePageView, 500);
      }
    }

    firePageView();
  }, [location]);
}
